import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';

import { Button, FormikCheckbox } from '@febos-io/design';

import { useEditCompanyUserCallback, useTranslation } from '../hooks';

const optionRoles = [
  { value: 'radiologist', label: 'Radiólogo' },
  { value: 'radiology-technician', label: 'Técnico radiólogo' },
  { value: 'dentist', label: 'Odontólogo' }
];

export function User(
  {
    user
  }
) {
  const { t } = useTranslation();

  const {
    loading,
    onSubmit
  } = useEditCompanyUserCallback(user.id);

  return (
    <div className="d-flex flex-column justify-content-between flex-grow-1">
      <div className="row gx-2">
        <p>
          {t('Name')}
          :
          {user.name}
        </p>
        <p>
          {t('Middle Name')}
          :
          {user.middleName}
        </p>
        <p>
          {t('Last Name')}
          :
          {user.lastName}
        </p>
        <p>
          {t('Mother\'s Last Name')}
          :
          {user.motherLastName}
        </p>
        <p>
          {t('Email')}
          :
          {user.email}
        </p>
        <p>
          {t('Date')}
          :
          {user.createAt}
        </p>
      </div>
      <Formik
        initialValues={{
          roles: user.roles
        }}
        onSubmit={onSubmit}
      >
        <Form>
          <div>
            <h6>Rol:</h6>
            {optionRoles.map((option) => (
              <FormikCheckbox
                value={option.value}
                label={option.label}
                key={option.value}
                name="roles"
              />
            ))}
          </div>
          <div className="text-end mt-3">
            <Button
              type="submit"
              loading={loading}
            >
              {t('Edit user')}
            </Button>
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default User;

User.propTypes = {
  user: PropTypes.object
};
